import { render } from "./VenditeDataTable.vue?vue&type=template&id=c9022d20&scoped=true"
import script from "./VenditeDataTable.vue?vue&type=script&lang=js"
export * from "./VenditeDataTable.vue?vue&type=script&lang=js"

import "./VenditeDataTable.vue?vue&type=style&index=0&id=c9022d20&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9022d20"]])

export default __exports__